import { Components, Theme } from '@mui/material';

const MuiTablePagination: Components<Theme>['MuiTablePagination'] = {
  styleOverrides: {
    root: {
      '& .MuiTablePagination-selectLabel': {
        marginBottom: 0,
      },
      '& .MuiTablePagination-displayedRows': {
        marginBottom: 0,
      },
    },
  },
};

export default MuiTablePagination;
